import { create } from 'zustand';
import type { SortKeyFoundPhenomenons } from './area-day-info/components/area-day-info-events-monitoring/components/found-occurrences-by-categories/found-occurrences-by-categories.constants';
import type { TimelineWindowEventsFromBff } from './timeline.models';

export interface SelectedWindow {
  areaId: string;
  start: string;
  end: string;
}

interface TimelineFieldDetailsStore {
  showTimelineBar: boolean;
  setShowTimelineBar: (value: boolean) => void;
  setCurrentWindowEvents: (currentWindowEvents: TimelineWindowEventsFromBff | undefined) => void;
  currentWindowEvents: TimelineWindowEventsFromBff | undefined;
  isFoldCollapsePhenomenonFound: boolean;
  setIsFoldCollapsePhenomenonFound: (value: boolean) => void;
  phenomenonsFoundSortedBy?: SortKeyFoundPhenomenons;
  setPhenomenonsFoundSortedBy: (value: SortKeyFoundPhenomenons) => void;
  isPhenomenonsFoundSortingLoading: boolean;
  setIsPhenomenonsFoundSortingLoading: (value: boolean) => void;
  setWindowParams: (value: SelectedWindow | undefined) => void;
  windowParams?: SelectedWindow;
  isLoadingWindowEvents: boolean;
  setIsLoadingWindowEvents: (value: boolean) => void;
}

export const useTimelineFieldDetailsStore = create<TimelineFieldDetailsStore>()(set => ({
  showTimelineBar: true,
  setShowTimelineBar: showTimelineBar => set({ showTimelineBar }),
  setCurrentWindowEvents: currentWindowEvents => set({ currentWindowEvents }),
  currentWindowEvents: undefined,
  isFoldCollapsePhenomenonFound: true,
  setIsFoldCollapsePhenomenonFound: isFoldCollapsePhenomenonFound => set({ isFoldCollapsePhenomenonFound }),
  phenomenonsFoundSortedBy: undefined,
  setPhenomenonsFoundSortedBy: phenomenonsFoundSortedBy => set({ phenomenonsFoundSortedBy }),
  isPhenomenonsFoundSortingLoading: false,
  setIsPhenomenonsFoundSortingLoading: isPhenomenonsFoundSortingLoading => set({ isPhenomenonsFoundSortingLoading }),
  windowParams: undefined,
  setWindowParams: windowParams => set({ windowParams }),
  isLoadingWindowEvents: false,
  setIsLoadingWindowEvents: isLoadingWindowEvents => set({ isLoadingWindowEvents })
}));
